import { useEffect, useState } from "react";
import axios from "axios";
import { useGetUserId } from "../hooks/useGetUserId";

export const Collection = () => {
  const [savedCards, setSavedCards] = useState([]);
  const userID = useGetUserId();

  // ADD WISHLIST, NEEDED IN CARDS.JS AS WELL
  useEffect(() => {
    const fetchSavedCards = async () => {
      try {
        const response = await axios.get(
          `http://localhost:3001/cards/savedCards/${userID}`
        );
        setSavedCards(response.data.savedCards);
      } catch (err) {
        console.error(err);
      }
    };

    fetchSavedCards();
  }, [userID]);

  return (
    <div>
      {" "}
      <h1>Your Collection</h1>
      <ul>
        {savedCards.map((card) => (
          <li key={card._id}>
            <div>
              <h2>{card.setName}</h2>
            </div>
            <div>
              <h2>{card.name}</h2>
            </div>
            <img src={card.imageUrl} alt={card.name} />
            <h3>Market Price: ${card.price}</h3>
          </li>
        ))}
      </ul>
    </div>
  );
};
